import React, { Component } from 'react';
import { Table, Button, Form, Segment , Divider} from 'semantic-ui-react';
import { serverIp, toCurrency, } from '../../../../config/constants.js'
import axios from 'axios'
import PayItemRow from './PayItemRow.js';
import * as UiConsts from '../../../../config/UiConstants';

function ShowExpenseAccounts(props) {

    const rows = props.expenseAccounts.length > 0
        ? props.expenseAccounts.map((item) =>
            <Table.Row>
                <Table.Cell> {item.accountName} </Table.Cell>
                <Table.Cell>{toCurrency(item.balance)}</Table.Cell>
            </Table.Row>)
        : ''

    return (
        <div>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Account</Table.HeaderCell>
                        <Table.HeaderCell>Amount</Table.HeaderCell>

                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {rows}
                </Table.Body>

            </Table>
        </div>
    )
}

class SearchOrderNumInReceipts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            itemArray: [],
            checkNumber: '',
            recNum:''
        }
    }


    componentDidMount() {
        console.log("++++++++:componentDidMount");

    }


    handleChange = (e) => {
        console.log("hx1 >>>>: handleChange clicked");
        console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);

        let newState = {};
        newState[e.target.name] = e.target.value;
        this.setState(newState);

    }

    findByOrderNum = () => {
        this.checkServer("order_num", this.state.order_num);
    }

    findByRecNum= () => {
        this.checkServer("recNum", this.state.recNum);
    }

    checkServer = (checkString, checkNumber) => {
        console.log("++++++++:findOrderNum");
        console.log("checkString:"+checkString);
        console.log("checkNumber:"+checkNumber);

        if (this.state.order_num == '' && checkString == 'order_num') {
            console.log("order num is blank");
            alert("order num is blank");

        }else if (this.state.recNum == '' && checkString == 'recNum') {
            console.log("Receipt num is blank");
            alert("Receipt num i is blank");
        } else {


            this.setState({ loading: true, itemArray:[]});

            axios.post(serverIp + 'billing/searchByReceiptNumOrOrderNum', {
                apiKey: "ad#4fsdUUddf",
                checkNumber: checkNumber,
                checkString: checkString
            })
                .then((response) => {
                    console.log("dud1:" + JSON.stringify(response.data, null, 3));

                    if (response.data.result) {

                        this.setState({
                            loading: false,
                            itemArray: response.data.receiptOrderNumsList,
                        }, this.clearFeild());

                    } else {
                        this.setState({ loading: false });
                        alert(response.data.message);
                    }
                    //this.resetFields();
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ loading: false })
                });
        }
    }

   clearFeild = () =>{
       console.log("+++++ clearFeilds");
       this.setState({
        checkNumber: '',
        recNum:'',
        order_num:''
       })
   }

    render() {

        const rows = this.state.itemArray.length > 0
            ? this.state.itemArray.map((item) =>
                <Table.Row>
                    <Table.Cell> {item.reciepts.orderNum} </Table.Cell>
                    <Table.Cell>{item.reciepts.recieptNum}</Table.Cell>
                    <Table.Cell>{item.reciepts.dateStamp}</Table.Cell>
                    <Table.Cell>{item.reciepts.daDate}</Table.Cell>
                    <Table.Cell>{item.reciepts.amountRec}</Table.Cell>
                    <Table.Cell>{item.reciepts.amountDep}</Table.Cell>
                    <Table.Cell>{item.reciepts.enteredByAdmin.email}</Table.Cell>
                    <Table.Cell>{item.reciepts.checkString}</Table.Cell>
                </Table.Row>)
            : ''

        const tableHeader = this.state.itemArray.length > 0
            ? <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Order Num</Table.HeaderCell>
                        <Table.HeaderCell>Receipt Num</Table.HeaderCell>
                        <Table.HeaderCell>Date Entered</Table.HeaderCell>
                        <Table.HeaderCell>Date Delivered</Table.HeaderCell>
                        <Table.HeaderCell>Amount Rec</Table.HeaderCell>
                        <Table.HeaderCell>Amount Del</Table.HeaderCell>
                        <Table.HeaderCell>Entered By</Table.HeaderCell>
                        <Table.HeaderCell>checkString</Table.HeaderCell>

                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {rows}
                </Table.Body>

            </Table>
            : ''

        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>

            <h3> Search Receipt By Order Num</h3>

            <Form size='large' onSubmit={this.findByOrderNum}>
                <Segment stacked>
                    <Form.Input
                        fluid
                        icon='user'
                        iconPosition='left'
                        placeholder='Order Number'
                        name="order_num"
                        value={this.state.order_num}
                        type="number"
                        onChange={this.handleChange}
                    />
                    <Button color='teal' fluid size='large'>Search</Button>
                </Segment>
                </Form>

                
                <h3>Search by Receipt Number</h3>
                <Form size='large' onSubmit={this.findByRecNum}>
                <Segment stacked>
                    <Form.Input
                        fluid
                        icon='user'
                        iconPosition='left'
                        placeholder='Receipt Number'
                        name="recNum"
                        value={this.state.recNum}
                        type="number"
                        onChange={this.handleChange}
                    />
                    <Button color='teal' fluid size='large'>Search</Button>
                   
                </Segment>
                </Form>
            
                <Divider horizontal>{'SEARCH RESULTS'}</Divider>
            {tableHeader}
            <Divider horizontal>{'--------------'}</Divider>
        </div>);
    }
}

export default SearchOrderNumInReceipts;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Billing/SearchOrderNumInReceipts.js